// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"436":"d84251bd","488":"29b71886","511":"db4216c2","658":"04778191","973":"ca84641b","992":"5563ecc7"}[chunkId] + ".chunk.js";
};